<template>
  <v-container fluid>
    <v-divider></v-divider>
    <h3 style="width:100%; text-align: center; color:yellow;">{{ stationInfo }} </h3>
    <v-divider></v-divider>
    
    <v-row 
      v-for="(rowItems, rowIndex) in groupedDashboardItems" 
      :key="rowIndex"
    >
      <v-col 
        v-for="(item, colIndex) in rowItems" 
        :key="colIndex" 
      >
        <v-card>
          <v-card-title style="text-align: center;">{{ item.title }}</v-card-title>
          <v-card-text class="d-flex justify-center align-center" style="height: 100%">
            <div  v-if="item.type === 'circle'">
              <v-progress-circular
                :value="item.value"
                :size="150"
                :width="10"
                :color="item.color"
                rotate="-90"
              >
                <div class="d-flex flex-column align-center">
                  <img 
                    :src="item.icon" 
                    :alt="item.title" 
                    class="theme-icon"
                    style="width: 48px; height: 48px;"
                  />
                  <span>{{ item.value }} {{ item.unit }}</span>
                </div>
              </v-progress-circular>
            </div>
            <div v-else-if="item.type === 'square-box'">
              <v-card class="square-box" elevation="2" :style="{ border: item.range === '1' ? '8px solid red' : '' }"> 
                <v-card-text class="d-flex flex-column align-center"> 
                  <div  style="font-size: 20px;">
                    <span>{{ item.value.split(',')[3] }}</span><br/>
                    <span>{{ item.value.split(',')[0] }}</span><br/>
                    <span>{{ item.value.split(',')[1] }}</span><br/>
                    <span>{{ item.value.split(',')[2] }}</span> 
                  </div> 
                </v-card-text>
              </v-card>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <div>
      <div style="position: relative;">
        <br/>
        <br/>
        <v-main>
          <v-container fluid>
            <v-row :class="`grid-${gridLayout}`">
              <v-col
                v-for="(video, index) in currentPageVideos"
                :key="`${video.id}-${currentPage}-${index}`"
                :cols="calculateColumnSize()"
              >
                <v-card height="100%">
                  <v-responsive :aspect-ratio="16/9">
                    <v-card-subtitle>{{ video?.name || '讀取資料中...' }}</v-card-subtitle>
                    <VideoComponent
                      :url="video.url"
                      :username="video.account"
                      :password="video.password"
                    />
                  </v-responsive>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-main>
        <br/>
        <br/>
        <h4 style="position: absolute; left: 50%; transform: translate(-50%, -50%);">
          人次統計 8小時
        </h4>
        <br/>
        <br/>
      </div>
      <LineChart :chartData="chartData" :chartOptions="chartOptions" ref="lineChart"></LineChart>
    </div>
    <br>
    <br>
    <ht>事件檢視</ht>
    <br>
    <br>
    <v-row>   
      <v-col cols="4" sm="6">
        <v-text-field
          v-model="search"
          label=" 搜&nbsp;&nbsp;尋"
          clearable
          @click:clear="clearFilter"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-data-table 
      :items="filteredItems"
      :headers="headers"
      item-key="row"
      :items-per-page="10"
      no-data-text="無資料"
      fixed-header
      items-per-page-text="每頁顯示筆數"
      loading-text="載入中"
      :pageText="'{0}-{1} 之 {2}'"
    >
      <template v-slot:[`item.row`]="{ item }">
        <div>{{ item.row }}</div>
      </template>
      <template v-slot:[`item.recordTime`]="{ item }">
        <div>{{ item.recordTime }}</div>
      </template>
      <template v-slot:[`item.areaName`]="{ item }">
        <div>{{ item.areaName }}</div>
      </template>
      <template v-slot:[`item.deviceName`]="{ item }">
        <div>{{ item.deviceName }}</div>
      </template>
      <template v-slot:[`item.playback`]="{ item }">
        <v-icon v-if="item.areaName.indexOf('情人')!=-1"
          @click="playbackVideo(item)"
          color="primary"
          @click.prevent
        >
          mdi-play
        </v-icon>
      </template>
    </v-data-table>
    <VideoPopup ref="videoPopupRef" />
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
  </v-container>
</template>

<script setup>
import { ref, computed, watch, onMounted, onBeforeUnmount, nextTick } from 'vue';
import CircularGauge from '../components/CircularGauge.vue'; 
import axios from 'axios';
import { LineChart } from 'vue-chart-3';
import 'chartjs-adapter-date-fns';
import VideoComponent from '@/components/VideoComponent2.vue';
import VideoPopup from '@/components/VideoPopup.vue';
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  TimeScale,
} from "chart.js";
import { useStore } from '@/stores/mainStore';
import { useAuthStore } from '@/stores/auth';

// Register ChartJS components
ChartJS.register(LineElement, PointElement, LinearScale, Title, Tooltip, Legend, TimeScale);

// Props
const props = defineProps({
  areaId: {
    type: Number,
    required: true,
  }
});

// API URL
const apiUrl = window.config.API_URL;

// Refs
const search = ref("");
const items = ref([]);
const videoSources = ref([]);
const currentPage = ref(1);
const gridLayout = ref('4');
const videoPlayer = ref(null);
const isClient = ref(false);
const chartInstance = ref(null);
const dashboardItems = ref([]);
const dashboardData = ref(null);
const stationInfo = ref(null);
const humidityColor = ref('white');
const timeoutId = ref(null);
const rainRate = ref(20.0);
const humidity = ref(80.0);
const temperature = ref(19.2);
const videoPopupRef = ref(null);

const localAreaId = ref(props.areaId);
const lineChart = ref(null);
const refreshInterval = ref(null);

// Chart options
const chartOptions = ref({
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    x: {
      display: true,
      type: 'time',
      time: {
        unit: 'hour',
        parser: 'YYYY-MM-DD HH',
        tooltipFormat: 'll HH:mm:ss',
        displayFormats: {
          hour: 'YYYY-MM-DD HH', 
        },
      },
      title: {
        display: true,
        text: '時間',
      },
    },
    y: {
      title: {
        display: true,
        text: '人次',
      },
    },
  },
});

// Chart data
const chartData = ref({
  labels: [],
  datasets: [
    {
      label: '',
      data: [],
      borderColor: 'blue',
      fill: false
    },
    {
      label: '',
      data: [],
      borderColor: 'blue',
      fill: false
    },
    {
      label: '',
      data: [],
      borderColor: 'red',
      fill: false
    }
  ],
});

// Table headers
const headers = ref([
  { title: '序號', key: 'row', align: 'center', sortable: true },
  { title: '事件時間', key: 'recordTime', align: 'center', sortable: true },
  { title: '地點', key: 'areaName', align: 'center', sortable: true },
  { title: '設備名稱', key: 'deviceName', align: 'center', sortable: true },
  { title: '事件訊息', key: 'status', align: 'center', sortable: true },
  { title: '事件影像', key: 'playback', align: 'center', sortable: true },
]);

// Computed properties
const filteredItems = computed(() => {
  if (search.value == null || search.value == '')
    return items.value;
  else
    return items.value.filter(item => {
      return (
        item.recordTime.toLowerCase().includes(search.value.toLowerCase()) ||
        item.deviceName.toLowerCase().includes(search.value.toLowerCase()) ||
        item.areaName.toString().toLowerCase().includes(search.value.toLowerCase()) ||
        item.status.toString().toLowerCase().includes(search.value.toLowerCase()) ||
        search.value === ''
      );
    });
});

const currentPageVideos = computed(() => {
  if (videoSources.value.length <= 0)
    return [];
    
  const itemsPerPage = parseInt(gridLayout.value);
  const start = (currentPage.value - 1) * itemsPerPage;
  const end = start + itemsPerPage;

  const areaChannels = videoSources.value[0].channels;
  const pageVideos = areaChannels.slice(start, end);
  
  console.log('Current Page Videos:', pageVideos);
  return pageVideos;
});

const groupedDashboardItems = computed(() => {
  console.log('grouped begin');
  try {
    const grouped = [];
    for (let i = 0; i < dashboardItems.value.length; i += 4) {
      grouped.push(dashboardItems.value.slice(i, i + 4));
    }
    console.log('grouped', grouped);
    return grouped;
  } catch(e) {
    return null;
  }
});

// Methods
const playbackVideo = (item) => {
  console.log('videoPopup', videoPopupRef.value);
  console.log('item', item);
  videoPopupRef.value.openPopup(item.playback, "chien", "jimmy456");
};

const clearFilter = () => {
  search.value = '';
};

const resetVideoPlayers = () => {
  if (videoSources.value.length <= 0)
    return;
    
  nextTick(() => {
    currentPageVideos.value.forEach((video, index) => {
      // Use the specific ref for this video
      const videoElements = document.querySelectorAll(`[data-video-index="${index}"]`);
      
      if (videoElements && videoElements.length > 0) {
        const videoElement = videoElements[0];
        
        try {
          // Ensure URL is valid
          if (video.url) {
            console.log(`WSFMP4 initialized for video ${index}:`, video.url);
          }
        } catch (error) {
          console.error(`Error initializing WSFMP4 for video ${index}:`, error);
        }
      }
    });
  });
};

const calculateColumnSize = () => {
  const layoutMap = {
    '1': 12,
    '4': 6,
    '9': 4,
    '16': 3
  };
  return layoutMap[gridLayout.value];
};

const fetchDashboardItems = async () => {
  try {
    const mainStore = useStore();
    const response = await axios.get(`${apiUrl}/bridge/persons?areaid=${mainStore.areaId}`);
    console.log('[persons]',response.data);
    dashboardData.value = response.data;
    stationInfo.value = dashboardData.value.stationName;
    dashboardItems.value = dashboardData.value.listHumanPerson;
    
    const labels = dashboardData.value.listHumanFlowSub.map(item => item.createTime);
    const totalInData = dashboardData.value.listHumanFlowSub.map(item => item.totalIn);
    const totalOutData = dashboardData.value.listHumanFlowSub.map(item => item.totalOut);
    const bridgePersons = dashboardData.value.listHumanFlowSub.map(item => item.bridgePerson);

    chartData.value = {
      labels: labels,
      datasets: [
        {
          label: '總進入人次',
          data: totalInData,
          borderColor: 'lightblue',
          tension: 0,
          fill: false
        },
        {
          label: '總離開人次',
          data: totalOutData,
          borderColor: 'lightgreen',
          tension: 0,
          fill: false
        },
        {
          label: '橋上人次',
          data: bridgePersons,
          borderColor: 'red',
          tension: 0,
          fill: false
        }
      ]
    };
  } catch (error) {
    console.error('Error fetching dashboard items:', error);
  }
};

const fetchEvents = async () => {
  try {
    const response = await axios.get(`${apiUrl}/event/getEvents`);
    items.value = response.data;
  } catch (error) {
    console.error('Error fetching events:', error);
  }
};

const startPeriodicRefresh = () => {
  if (refreshInterval.value) {
    clearInterval(refreshInterval.value);
  }
  
  // Start new interval
  refreshInterval.value = setInterval(() => {
    fetchDashboardItems();
    fetchEvents();
  }, 10000); // Refresh every 10 seconds
};

const waterArea = (isOpen) => {
  // Implementation needed
  console.log('Water area', isOpen ? 'opened' : 'closed');
};

// Watch properties
watch(() => props.areaId, (newValue) => {
  console.log('newValue', newValue);
  localAreaId.value = newValue;
});

// Lifecycle hooks
onMounted(async () => {
  console.log('humanFlow areaId', props.areaId);
  localAreaId.value = props.areaId;

  try {
    console.log('videosorce', `${apiUrl}/camera/getHumanCamera`);
    const response = await axios.get(`${apiUrl}/camera/getHumanCamera`);
    console.log('video sources', response.data);
    videoSources.value = response.data;
    resetVideoPlayers();
    fetchEvents();
  } catch (error) {
    console.error('Failed to fetch video sources:', error);
  }
  
  fetchDashboardItems();
  fetchEvents();
  startPeriodicRefresh();
});

onBeforeUnmount(() => {
  if (refreshInterval.value) {
    clearInterval(refreshInterval.value);
  }
  
  if (chartInstance.value) {
    chartInstance.value.destroy();
  }
  
  if (timeoutId.value) {
    clearTimeout(timeoutId.value);
  }
});
</script>

<style>
.v-progress-circular {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.theme-icon {
  width: 48px;
  height: 48px;
  filter: 
    invert(61%)   /* Invert the color */
    sepia(14%)    /* Add some color depth */
    saturate(3166%) 
    hue-rotate(176deg)  /* Shift to blue tones */
    brightness(101%) 
    contrast(101%);
}

.square-box { 
  display: flex; 
  align-content: center; 
  justify-content: center; 
  align-items: center; 
  height: 180px; 
  width: 400px; 
  border: 8px solid rgba(127, 127, 127, 0.233); 
  box-sizing: border-box; 
  margin: auto;
} 

.square-box1 {
  flex: 1; 
  max-width: 150px;
  margin: auto;
}
  
.d-flex { 
  display: flex; 
} 
  
.flex-column { 
  flex-direction: column; 
} 

.align-center { 
  align-items: center; 
  justify-content: center; 
  text-align: center; 
}

.auto-center {
  display: flex;
  justify-content: center; 
  align-items: center;    
  height: 100%;           
}
</style>